
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#234652","stroke-width":".8","d":"M9.248 11.999h20.249v2.709H9.248zM10.105 13.353h9.017"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M8.848 9.441h7.894v1.36H8.848zM8.848 22.169h5.761v1.36H8.848z"}}),_c('circle',{attrs:{"cx":"10.602","cy":"26.201","r":"1.354","stroke":"#234652","stroke-width":".8"}}),_c('circle',{attrs:{"cx":"19.372","cy":"26.201","r":"1.354","stroke":"#234652","stroke-width":".8"}}),_c('circle',{attrs:{"cx":"14.987","cy":"26.201","r":"1.754","fill":"#D0EFEC"}}),_c('circle',{attrs:{"cx":".805","cy":".805","r":".405","stroke":"#234652","stroke-width":".8","transform":"matrix(1 0 0 -1 14.183 27.005)"}}),_c('circle',{attrs:{"cx":"23.757","cy":"26.201","r":"1.354","stroke":"#234652","stroke-width":".8"}}),_c('circle',{attrs:{"cx":"28.142","cy":"26.201","r":"1.354","stroke":"#234652","stroke-width":".8"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M9.362 30.809h10.351v4.119H9.362z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":".8","d":"M9.248 30.932h9.086v2.709H9.248zM29.6 17.444v2.726H9.248v-2.726zM10.11 18.807h3.527M26.874 20.57v-3.526M27.937 18.807h.6"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":".8","d":"M33.129 27.515V6.056c0-.583-.473-1.056-1.056-1.056H6.815c-.583 0-1.056.473-1.056 1.056v32.316c0 .583.473 1.056 1.056 1.056h12.628"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":".8","d":"M22.753 29.904h18.454V42.6H22.753z"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M40.3 33.244H21.195v3.474H40.3z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":".8","d":"M22.546 32.159H41.38m-18.834 3.04H41.38"}})])
          )
        }
      }
    